import { render, staticRenderFns } from "./DataTable6.vue?vue&type=template&id=7878a684&scoped=true"
import script from "./DataTable6.vue?vue&type=script&lang=js"
export * from "./DataTable6.vue?vue&type=script&lang=js"
import style0 from "./DataTable6.vue?vue&type=style&index=0&id=7878a684&prod&lang=scss&scoped=true"
import style1 from "./DataTable6.vue?vue&type=style&index=1&id=7878a684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7878a684",
  null
  
)

export default component.exports